import { ReadCountryListResponse } from "@/types/util"
import { API } from "."
import {
  CreateVerifyMailResponse,
  ReadAccountInfoResponse,
  CreateProfileImageResponse,
  UpsertUserInfoPayload,
  CreateProfileImagePayload,
  UpsertPasswordPayload,
  UpsertInviteMailPayload,
  VerifyAuthCodeResponse,
  CreateVerifyMailParams,
  CreateTableauTokenResponse,
  CreateTableauViewsPayload,
  CreateTableauViewsResponse,
  CreateTableauWorkbooksPayload,
  CreateTableauWorkbooksResponse,
  CreateTableauViewPayload,
  CreateTableauViewResponse,
  UpsertLanguagePayload,
} from "@/types/account"

/* 초대 코드 검증 */
export async function verifyAuthCode(authCode: string) {
  return await API.post<VerifyAuthCodeResponse>(`/accounts/verify-auth-code?authCode=${authCode}`)
}
/* 이메일 검증 */
export async function createVerifyEmail(params: CreateVerifyMailParams) {
  const { email, authCode } = params

  return await API.post<CreateVerifyMailResponse>(
    `/accounts/verify-email?email=${email}&authCode=${authCode}`,
  )
}
/* 유저 계정 정보 조회 */
export async function readAccountInfo(idfAccount: number) {
  return await API.get<ReadAccountInfoResponse>(`/accounts/${idfAccount}`)
}
/* 유저 정보 수정 */
export async function upsertUserInfo(data: { idfAccount: number; payload: UpsertUserInfoPayload }) {
  const { idfAccount, payload } = data

  return await API.put<void>(`/accounts/${idfAccount}`, payload)
}
/* 이미지 관련 */
export async function createProfileImage(payload: CreateProfileImagePayload) {
  return await API.post<CreateProfileImageResponse>(`/accounts/registImage`, payload)
}
export async function deleteProfileImage(idfAccount: string) {
  return await API.delete<void>(`/accounts/${idfAccount}/image`)
}
/* 유저 계정 암호 변경 */
export async function upsertPassword(payload: UpsertPasswordPayload) {
  return await API.put<void>("/accounts/password", payload)
}
/* 초대 이메일 발송 */
export async function createInviteEmail(payload: UpsertInviteMailPayload) {
  return await API.post<void>(`/accounts/send-invite-email`, payload)
}

/* 태블로 로그인 */
export async function createTableauToken() {
  return await API.post<CreateTableauTokenResponse>(`/tableau/signin`)
}
/* 태블로 Views 요청 */
export async function createTableauViews(payload: CreateTableauViewsPayload) {
  return await API.post<CreateTableauViewsResponse>(`/accounts/tableau-views`, payload)
}

/* 태블로 workbooks 요청 */
export async function createTableauWorkbooks(payload: CreateTableauWorkbooksPayload) {
  return await API.post<CreateTableauWorkbooksResponse>(`/tableau/workbooks`, payload)
}

/* 태블로 workbook의 views 요청 */
export async function createTableauView(data: {
  workbookId: string
  payload: CreateTableauViewPayload
}) {
  const { workbookId, payload } = data

  return await API.post<CreateTableauViewResponse>(
    `/tableau/workbooks/${workbookId}/views`,
    payload,
  )
}

/* 회원가입 시 국가 리스트 가져오기  */
export async function getCountryList() {
  return await API.get<ReadCountryListResponse>("/util/countries")
}

/* Language */
export async function upsertLanguage(payload: UpsertLanguagePayload) {
  return await API.put<void>("/accounts/language", payload)
}
